import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import blogData from "../data/blogData";

export default function BlogDetails() {

    const { t } = useTranslation();
    const { id } = useParams();
    UseScrollAnimation();

    const blog = blogData.find((item) => item.id === id);


    if (!blog) {
        return <div>Blog not found.</div>;
    }
    return (
        <>
            <section className="blog-landing">
                <div className="container relative h-full flex flex-col items-center justify-center">
                    <div className="">
                        <div className="font-bold text-white text-[40px] capitalize">{t("Blog Details")}</div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[40px]">
                    <div className="flex flex-col gap-[3px]">
                        <div className="text-[30px] font-bold text-[#0B2C3D]">{t(`${blog.fullTitle}`)}</div>
                        <img className="h-[3px]" src={require("../../assets/icons/line-text.svg").default} alt="" />
                    </div>
                    <div className="flex flex-col gap-[20px]">
                        <div>{t(`${blog.details}`)}</div>
                    </div>
                </div>
            </section>
        </>
    );
}